export function redirectToLogin() {
  let homeURL = process.env.REACT_APP_LAMBDATEST_HOME || (window._env_ && window._env_.REACT_APP_LAMBDATEST_HOME);
  window.location.replace(
    `${homeURL}/login`,
    '_self'
  );
}
